import lodash from 'lodash';

function findIndexOfMatchingPayment(sorcererPayments, sysopenPayment) {
  const matchingIndex = lodash.findIndex(sorcererPayments, (sorcererPayment) => {
    const sorcererInstallmentNum = Number(sorcererPayment.installment_number);
    const sysopenInstallmentNum = Number(sysopenPayment.installment_number);

    return sorcererInstallmentNum === sysopenInstallmentNum;
  });
  if (matchingIndex >= 0) {
    return matchingIndex;
  }

  throw new Error('Unable to match Sorcerer payment with SysOpen installment');
}

function hasDefaultedPayments(plan) {
  const pastDueInstallments = lodash.filter(plan.installments, (installment) => installment.status === 'defaulted');

  return pastDueInstallments.length > 0;
}

function enrichSorcererPayments(paid, unpaid, sysopenPayments, paymentPlans) {
  const transformedPayments = [];

  paid.forEach((p) => {
    const enrichedPayment = p;
    enrichedPayment.status = 'paid_off';

    transformedPayments.push(enrichedPayment);
  });

  unpaid.forEach((p) => {
    const enrichedPayment = p;
    enrichedPayment.status = 'unpaid';

    transformedPayments.push(enrichedPayment);
  });

  sysopenPayments.forEach((sysopenPayment) => {
    const i = findIndexOfMatchingPayment(transformedPayments, sysopenPayment);
    transformedPayments[i].outstanding_amount = sysopenPayment.outstanding_amount;
    transformedPayments[i].status = sysopenPayment.status; // will be pending or defaulted
  });

  paymentPlans.forEach((plan, paymentPlanNum) => {
    plan.contract_installments.forEach((contractInstallment) => {
      const i = findIndexOfMatchingPayment(transformedPayments, contractInstallment);
      transformedPayments[i].active_payment_plan_number = Number(paymentPlanNum) + 1;
    });
    if (hasDefaultedPayments(plan)) {
      plan.contract_installments.forEach((installment) => {
        const i = findIndexOfMatchingPayment(transformedPayments, installment);
        transformedPayments[i].status = 'defaulted';
      });
    } else {
      plan.contract_installments.forEach((installment) => {
        const i = findIndexOfMatchingPayment(transformedPayments, installment);
        transformedPayments[i].status = 'under_payment_plan';
        transformedPayments[i].payment_plan_id = plan.id;
      });
    }
  });

  return lodash.sortBy(transformedPayments, (p) => Number(p.installment_number));
}
export {
  enrichSorcererPayments, hasDefaultedPayments,
};
